<template>
  <!-- Formulario -->
  <v-form ref="form" autocomplete="off">
    <v-row>
      <!-- Roles -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Id"
          :items="ArrayRoles"
          :item-title="(ArrayRoles) => ArrayRoles.Id + '-' + ArrayRoles.NombrePerfil"
          item-value="Id"
          color="primary"
          label="Roles: "
          dense
          hint="Digite Información"
          :rules="[rules.required]"
          readonly
        >
        </v-autocomplete>
      </v-col>

      <!-- Consecutivo -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.Consecutivo"
          label="Consecutivo:"
          :clearable="this.editedIndex != -1 ? false : true"
          :readonly="this.editedIndex != -1 ? true : false"
          dense
          maxlength="18"
          counter="18"
          type="tel"
          hint="Digite Información"
          :rules="[rules.required]"
          v-on:keypress="isNumber()"
        >
        </v-text-field>
      </v-col>

      <!-- Tipo de Perfil -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Tipo"
          :items="ArrayTipo"
          :item-title="(ArrayTipo) => ArrayTipo.Valor + '-' + ArrayTipo.Descripcion"
          item-value="Valor"
          label="Tipo de Perfil:"
          dense
          @update:modelValue="ChangeTipoPerfil()"
          :rules="[rules.required]"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Sub Roles -->
      <v-col v-if="editedItem.Tipo == TipoPerfil.Carpeta" cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.SubPerfilId"
          :items="ArrayRoles"
          :item-title="(ArrayRoles) => ArrayRoles.Id + '-' + ArrayRoles.NombrePerfil"
          item-value="Id"
          color="primary"
          label="Sub Rol: "
          dense
          :rules="editedItem.Tipo == TipoPerfil.Carpeta ? [rules.required] : []"
          hint="Digite Información"
        >
        </v-autocomplete>
      </v-col>

      <!-- Links -->
      <v-col v-if="editedItem.Tipo == TipoPerfil.Link" cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.LinkId"
          :items="
            ArrayLinks.map((x) => ({
              ...x,
              IDLink: String(x.IDLink),
            }))
          "
          :item-title="(ArrayLinks) => ArrayLinks.IDLink + '-' + ArrayLinks.Descripcion"
          item-value="IDLink"
          color="primary"
          label="Links:"
          dense
          :rules="editedItem.Tipo == TipoPerfil.Link ? [rules.required] : []"
          hint="Digite Información"
          clearable
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn size="x-large" v-if="!buttonSave" color="green" text @click="ValidateCampos">
        Guardar
      </v-btn>
    </div>
  </v-form>

  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img class="mx-auto" :width="5" src="/static/iconos/logo2.png"></v-img>
          </v-toolbar>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  putUpdate,
  postInsert,
  getConsecutivoPerfil,
} from "@/views/TCI/Seguridad/RelacionOpcionPerfil/RelacionOpcionPerfilService";
import {
  TablaSeleccion,
  TipoPerfil,
} from "@/views/TCI/Seguridad/Constantes/ConstantesSeguridad";
import { getConsultAllList } from "@/views/TCI/Seguridad/Links/LinksServices";

export default {
  name: "rop-registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "LLamado a Página Iframe",
    },
    componenteview: {
      type: Number,
      default: 0,
      Description: "Saber a que página llamar",
    },
    iconodialogbtn: {
      type: String,
      default: null,
      Description: "Información icono iframe",
    },
    titledialogbtn: {
      type: String,
      default: null,
      Description: "Información titulo iframe",
    },
    Exito: {
      type: String,
      default: null,
      Description: "Información de respuesta post o put",
    },
    perfilId: {
      type: Number,
      default: 0,
      Description: "Información de perfilId para consulta de consecutivo",
    },
  },
  data() {
    return {
      TipoPerfil,
      progreso: false,
      componenteview: 0,
      buttonSave: false,
      editedItem: {
        Id: this.perfilId,
        Consecutivo: null,
        Tipo: null,
        SubPerfilId: null,
        LinkId: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      defaultItem: {
        Id: this.perfilId,
        Consecutivo: null,
        Tipo: null,
        SubPerfilId: null,
        LinkId: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      ArrayRoles: [],
      ArrayLinks: [],
      ArrayTipo: [],
      rules: {
        required: (v) => !!v || "Campo obligatorio",

        email: (v) =>
          !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Correo electrónico inválido",
      },
    };
  },

  methods: {
    // Convertir a numero
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
        return;
      }

      // Consultas a Ejecutar
      var userperfil = this.$store.getters.userperfil;
      this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
      this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;

      if (this.editedIndex != -1) {
        this.putRegistro();
      } else {
        this.postRegistro();
      }
    },

    // Crear Registro
    async postRegistro() {
      this.progreso = true;
      try {
        const result = await postInsert(this.editedItem);
        this.reset();
        var data = false;
        this.$emit("update:page", data);
        this.$emit("update:Exito", result);
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Actualizacion de registro
    async putRegistro() {
      this.progreso = true;
      try {
        const result = await putUpdate(this.editedItem);
        this.reset();
        var data = false;
        this.$emit("update:page", data);
        this.$emit("update:Exito", result);
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Consulta Url
    async getUrl() {
      this.ArrayLinks = [];
      const result = await getConsultAllList();
      this.ArrayLinks = result;
    },

    // Consulta Consecutivo
    async getConsecutivo() {
      const result = await getConsecutivoPerfil(this.perfilId);
      this.editedItem.Consecutivo = result;
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
    },

    ChangeTipoPerfil() {
      this.editedItem.SubPerfilId = null;
      this.editedItem.LinkId = null;
    },

    // Cargue Combos
    CargueCombos() {
      var Tables = this.$store.getters.MTablaSeleccion;

      this.getUrl();

      var Perfil = this.$store.getters.MRol;
      this.ArrayRoles = Perfil;

      this.ArrayTipo = Tables.filter(
        (item) => item.Valor != null && item.TablaId == TablaSeleccion.TipoPerfil
      );
    },

    // Actualizar carga
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.editedItem = this.infoedit;
      } else {
        // Crear
        this.getConsecutivo();
      }
    },
  },
  mounted() {
    this.CargueCombos();
    this.ActualizarCargue();
  },
};
</script>
